exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scrollable-container[data-v-15a2485b] {\n  max-height: 80vh;\n  overflow-y: auto;\n}\n.fab-container[data-v-15a2485b] {\n  position: fixed;\n  background-color: white;\n  bottom: 16px;\n  right: 16px;\n  display: flex;\n  gap: 8px;\n  z-index: 1000;\n  padding-right: 40px;\n}\n.fab-container > .v-btn[data-v-15a2485b] {\n  margin: 0;\n}\n", ""]);

// exports
